export const editionActionsRowStyle = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
};

export const editionActionsInnerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  justifyContent: 'center',
  width: '100%',
  maxWidth: 640,
};

export const editionActionButtonStyle = { flex: '1 1 280px', minWidth: 200 };
